import { Github, Linkedin, Youtube, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const linkColumns = [{
  title: "Capabilities",
  links: [{
    label: "Market Expansion",
    to: "/ServicesPage"
  }, {
    label: "Technical Sales",
    to: "/ServicesPage"
  }, {
    label: "Industrial Outreach",
    to: "/ServicesPage"
  }, {
    label: "Vendor Integration",
    to: "/ServicesPage"
  }, {
    label: "Strategic Reporting",
    to: "/ServicesPage"
  }]
}, {
  title: "Industries",
  links: [{
    label: "Automotive",
    to: "/ServicesPage"
  }, {
    label: "Metal Fabrication",
    to: "/ServicesPage"
  }, {
    label: "Safety Systems",
    to: "/ServicesPage"
  }, {
    label: "Shipbuilding",
    to: "/ServicesPage"
  }, {
    label: "Enterprise",
    to: "/ServicesPage"
  }]
}, {
  title: "Resources",
  links: [{
    label: "Insights",
    to: "/AboutPage"
  }, {
    label: "Case Studies",
    to: "/AboutPage"
  }, {
    label: "Technical Guides",
    to: "/AboutPage"
  }, {
    label: "Documentation",
    to: "#"
  }, {
    label: "Support",
    to: "/ContactPage"
  }]
}];
const socials = [{
  name: "LinkedIn",
  icon: Linkedin,
  href: "#"
}, {
  name: "X",
  icon: Twitter,
  href: "#"
}, {
  name: "YouTube",
  icon: Youtube,
  href: "#"
}, {
  name: "GitHub",
  icon: Github,
  href: "#"
}];
const legalLinks = [{
  label: "Privacy",
  to: "#"
}, {
  label: "Terms",
  to: "#"
}, {
  label: "Security",
  to: "/AboutPage"
}];
function FooterCompanyMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  const items = menuItems.slice(0, 6);
  return <ul className="space-y-3">
      {items.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-sm font-default text-gray-400 hover:text-[#4BC545] transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="20262" id="footer" className="bg-[#070707] pt-24 pb-12 font-default">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 md:grid-cols-12">
          {}
          <div className="col-span-2 md:col-span-4">
            <Link to="/" aria-label="MetPro Partners home" className="inline-block">
              <WvcLogo className="h-7 w-auto text-white" />
            </Link>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-gray-400">MetPro Partners is a professional sales agency representing multiple companies in sales efforts. We bridge the gap between elite manufacturers and industrial buyers.</p>
            <ul className="mt-8 flex items-center gap-3">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <li data-index={i} key={social.name}>
                    <Link to={social.href} aria-label={social.name} className="inline-flex h-9 w-9 items-center justify-center border border-[#7C7C7C] text-gray-400 hover:text-[#4BC545] hover:border-[#4BC545] transition-all duration-200">
                      <Icon className="h-[18px] w-[18px]" strokeWidth={1.5} />
                    </Link>
                  </li>;
            })}
            </ul>
          </div>

          {}
          {linkColumns.map((column, i) => <div data-index={i} key={column.title} className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-[0.14em] text-[#4BC545]">
                {column.title}
              </h4>
              <ul className="mt-6 space-y-3">
                {column.links.map((link, j) => <li data-index={j} key={link.label}>
                    <Link to={link.to} className="text-sm font-default text-gray-400 hover:text-[#4BC545] transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          {}
          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.14em] text-[#4BC545]">
              Company
            </h4>
            <div className="mt-6">
              <MenuProvider menu_id="5">
                <FooterCompanyMenu />
              </MenuProvider>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 h-px w-full" style={{
        backgroundColor: "#7C7C7C"
      }} />

        {}
        <div className="mt-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
          <p className="text-[13px] font-medium tracking-[0.01em] text-gray-400">
            © 2025 MetPro Partners. All rights reserved.
          </p>
          <ul className="flex items-center gap-3">
            {legalLinks.map((link, i) => <li data-index={i} key={link.label} className="flex items-center gap-3">
                <Link to={link.to} className="text-[13px] font-medium tracking-[0.01em] text-gray-400 hover:text-[#4BC545] transition-colors duration-200">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-[#7C7C7C]" aria-hidden="true">
                    {"\u00B7"}
                  </span>}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}